




















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class NoDataFound extends Vue {
  @Prop() listing!: false;

  discard() {
    this.$emit('discard-no-data');
  }
}
